import { GlobalStore } from '@highlight/ipc'

/** The user's configured default model id, read from the settings store. */
export const useDefaultModelId = (): string | undefined => {
  return GlobalStore.settings().get<string>('defaultModel')
}
